import Box from "@mui/material/Box";
import React from "react";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { CardRow } from "../OpenBoxQuotes/BoxStructureFields";
import { NumberedSectionTitle } from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";
import { AccessoryNoteCard } from "./AccessoriesCards";
import { closedKey } from "./BoxStructureCards";

const Standard = () => {
  const styles = useStyles();

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={4}
        titleKey={formKey("SECTIONS.STANDARD")}
      />
      <CardRow columns={3}>
        <AccessoryNoteCard
          cardKey="sideGuardsReflectors"
          titleKey={closedKey("CARDS.SIDE_GUARDS_REFLECTORS")}
        />
        <AccessoryNoteCard
          cardKey="sideLighting"
          titleKey={closedKey("CARDS.SIDE_LIGHTING")}
        />
        <AccessoryNoteCard
          cardKey="standardMudguards"
          titleKey={closedKey("CARDS.STANDARD_MUDGUARDS")}
        />
      </CardRow>
    </Box>
  );
};

export default Standard;
